<template>
    <div class="container-fluid">
        <nav aria-label="breadcrumb" class="col-sm-12">
            <ol class="breadcrumb bg-orange mb-0">
                <li class="breadcrumb-item"><a href="/arcade/game-library" class="text-white"><i class="ri-home-4-line mr-1 float-left "  style="font-size: 20px;"></i>Game Library</a></li>
                <li v-for="item in list" v-bind:key="item.id" class="breadcrumb-item active text-white" aria-current="page">{{item.name}}</li>
            </ol>
        </nav>    
        <br>
        <b-col md="8" class="float-left" v-for="item in list" v-bind:key="item.id">
            <div>
                <img id="intro-img" :src="getGameImg(item.code)" @error="onImgError" width="100%">
            </div>
            <br>
                 <div class="row justify-content-between">
                <div class="col-sm-12 col-md-12">
                    <div class="card dataTables_filter">
                        <div class="card-body">
                        <form class="mr-2 position-relative row">
                            <div class="form-group mx-2 col-md-3">
                                <label for="sort">Language</label>
                                <select id="mode" class="form-control" @change="select_language($event)">
                                    <option selected value="en_US">English</option>
                                    <option value="zh_CN">Chinese</option>
                                </select>
                            </div>
                            <div class="form-group col-md-8" style="padding-top: 35px;">
                               
                                <b-button id="play_demo" pill variant="orange" class="text-white" @click="play_demo()">Play Demo Game</b-button> 
                            </div>
                        </form>
                        </div>
                    </div>
                </div>
            </div> 
            <br>
            <h4>Game Description (for Players)</h4>
            <br>
            <div class="justify-center">
                <p v-bind:style="{width : 'auto', 'text-align': 'justify'}" >{{ item.longDesc }}</p>
            </div>
         </b-col>
        <b-col lg="3" class="float-right  side-content" v-for="item in list" v-bind:key="item.id">
               <div id="gameplay" class="gameplay-container row m-0 justify-content-center" v-show="game_container">	
                <img id="demo-cover" :src="getGameCoverImg(item.code)" @error="onImgError">
					<img id="nxt-btn" v-on:click="game_container = !game_container" :src="require('../../../assets/images/gamepic/nextspin-btn.png')">
                    <b-button pill variant="orange" class="mt-2 mr-1 text-white" v-on:click="game_container = !game_container">Play Mini Version</b-button>
				</div>
                <iframe 
                    :src="('https://play.nextspin.com/games/game.php?game='+item.code+'&language=en_US')"
                    width="100%"
                    height="320"
                    v-if="!game_container">
                </iframe>
            <div class="card mt-3" cols="8">
                <table class="table table-borderless">
                    <tbody>
                        <tr>
                        <td id="title">Release Date</td>
                        <td>{{item.releaseDate}}</td>
                    </tr>
                    <tr>
                        <td id="title">Game Code</td>
                        <td>{{item.code}}</td>
                    </tr>
                    <tr>
                        <td id="title">RTP</td>
                        <td>{{item.rtp}}</td>
                    </tr>
                    <tr>
                        <td id="title">Line</td>
                        <td>{{item.line}}</td>
                    </tr>
                    <tr>
                        <td id="title">Reels X Rows</td>
                        <td>{{item.reels_rows}}</td>
                    </tr>
                    <tr>
                        <td id="title">Max Multiplier</td>
                        <td>{{item.max_multiplier}}</td>
                    </tr>
                    <tr>
                        <td id="title">Available On</td>
                        <td>
                            <span v-for="dom in item.platform" v-bind:key="dom.id">                               
                                <i v-if="dom === 'android'"  class="fab fa-android"></i>
                                <i v-if="dom === 'ios'" class="fab fa-apple"></i>
                                <i v-if="dom === 'web'"  class="fas fa-desktop"></i>    
                            </span>
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-for="item in setting" v-bind:key="item.id">
                        <tr>
                            <td id="title">Bet Base Multiplier</td>
                            <td>{{item.bet_base_multiplier}}</td>
                        </tr>
                        <tr>
                            <td id="title">Bet Base Values</td>
                            <td>{{item.bet_base_values}}</td>
                        </tr>
                        <tr>
                            <td id="title">Bet Values</td>
                            <td id="title">Bet Multiplier</td>               
                        </tr>
                        <tr>
                            <td>
                                <select id="select-bet" v-bind:style="{width : '70px'}" v-on:click="select_domination()" v-model="domination">
                                    <option selected v-for="dom in item.bet_values" v-bind:key="dom.id" :value="dom">
                                        {{dom}}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <select id="select-bet" v-bind:style="{width : '70px'}" v-on:change="select_multiplier($event)" v-model="multiplier">
                                    <option selected v-for="multi in item.bet_multiplier" v-bind:key="multi.id" :value="multi">
                                        {{multi}}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td id="title">Total Bet</td>
                            <td>{{totalBet}}</td>                
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card mt-3" cols="8" v-if="user.role_id != 3">
                <h5 style="text-align : center; padding: 10px" ><i class="fas fa-file-download"></i>Downloads</h5>
                <table class="table table-borderless">
                    <tbody>
                        <tr>
                            <td id="title">Thumbnails</td>
                            <td>
                                <b-button pill variant="outline-orange" @click="getFiles();downloadAll(link)">Download</b-button>
                            </td>
                        </tr>                  
                    </tbody>
                </table>
            </div>
         </b-col>
                                   
    </div>
</template>
<style scoped>
    p {
        width : "900px" !important;
        line-height: 1.5;
    }

    #title{
        font-weight: 500;
    }

    .card{
        border-radius: 20px;
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }

    #demo-cover{
        filter: brightness(60%);
    }

    #select-bet{
        border-radius: 20px;
        cursor: pointer;
        text-align:center;
    }
    #gameplay {
        position: relative;
        width: 100%;
        padding-top: 2% !important
    }

    #gameplay img {
        width: 100%;
        height: auto;
        border-radius: 10px;
    }

    #gameplay .btn {
        position: absolute;
        width: 45%;
        font-size: 13px;
        font-weight: 500px;
        top: 75%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 12px 24px;
        border: none;
        cursor: pointer;
        border-radius: 5px;
        text-align: center;
    }
     #gameplay #nxt-btn {
        position: absolute;
        width: 30%;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 12px 24px;
        border: none;
        cursor: pointer;
        border-radius: 5px;
        text-align: center;
    }

    .btn-orange{
        font-size: 16px;
    }

    .side-content i{
        color: #f26a0c;
        padding-right: 10px;
        font-size: 20px;
    }

    h5{
        font-weight: 500;
    }
</style>
<script>
import axios from 'axios';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import saveAs from 'save-as';
import Vue from 'vue';
import VueAxios from 'vue-axios';

const URL = require("../../../../config");
Vue.use(VueAxios, axios)

export default {
    name:'ArcadeDetail',
    data() {
        return {
            list: undefined,
            setting: undefined,
            currency: undefined,
            game_container: true,
            language: "en_US",
            selected_currency: "USD",
            domination: "",
            multiplier:"",
            totalBet: undefined,
            filename: "",
            link:[],
            common:[],
            user: undefined
        }
    },
    computed: {
        defaultImgUrl() {
            return process.env.BASE_URL + 'static/images/gamepic/default_img.png';
        }
    },
    created: async function() {
        this.user = JSON.parse(localStorage.getItem("user"));
    },
    async mounted() {
        let gamecode = this.$route.query.code
        let response = await Vue.axios.get(URL.api.URL + '/api/arcadedetail', { params: { code: gamecode, merchant: this.user.merchant_code, lang:this.user.language, m: this.$route.meta.uid } });

        this.list = response.data.game_detail
        this.setting = response.data.game_setting
        this.currency = response.data.game_currency

        this.setting.forEach(element => {
                this.domination = element.bet_values[0]
                this.multiplier = element.bet_multiplier[0]
            });

        this.totalBet = this.domination * this.multiplier
    },
    methods: {
        select_language(event) {
            var lang = event.target.value
            this.language = lang            
        },

        select_domination(){
            this.totalBet = this.multiplier * this.domination   
        },

        select_multiplier(event){
            var multi = event.target.value
            this.multiplier = multi  
            this.totalBet = this.domination * multi 
        },

        play_demo() {
            let gamecode = this.$route.query.code
            window.open("https://play.nextspin.com/games/game.php?game=" + gamecode + "&language=" + this.language, '_blank');
        },

        getFiles: async function() {
            let gamecode = this.$route.query.code
            let user = JSON.parse(localStorage.getItem("user"));

            let response = await Vue.axios.get(URL.api.URL+'/api/mediaPack/files', {
                params: {
                    m: this.$route.meta.uid,
                    merchant: user.merchant_code,
                    category: 'Arcade',
                    file: 'thumbnails',
                    gameCode: gamecode
                }
            });
            
            this.common = response.data.common
            this.merchant = response.data.merchant

             if (this.common.length <= 0 && this.merchant.length > 0) {
                this.filename = user.merchant_code
            }
            if (this.merchant.length <= 0 && this.common.length > 0) {
                this.filename = "Common"
            }
            if(this.merchant.length <= 0 && this.common.length <= 0){
                alert("Files are not found")
            }
            if(this.merchant.length > 0 && this.common.length > 0){
                this.filename = user.merchant_code + "_&_Common"
            }

            this.link = []
            this.common.forEach(element => {
                var url = {
                    link : element.url,
                    name: element.name+'.'+element.extension
                }  
                this.link.push(url)          
            });

            this.merchant.forEach(element => {
                var url = {
                    ink : element.url,
                    name: element.name+'.'+element.extension
                }      
                this.link.push(url)          
            });
            
            this.downloadAll(this.link)   
        },
        
        downloadAll() {
            let gamecode = this.$route.query.code
            var zip = new JSZip();
            var count = 0;
            var zipFilename = this.filename +"_" + gamecode + "_thumbnail.zip";
            var urls = this.link

            urls.forEach(function(url) {               
                var filename = url.name;               
                JSZipUtils.getBinaryContent(url.link, function (err, data) {
                    if(err) throw err;
                    
                    zip.file(filename, data, { binary: true });
                    count++;
    
                    if(count == urls.length) {
                        zip.generateAsync({ type: 'blob' })
                        .then(function(content) {
                            saveAs(content, zipFilename);
                        });
                    }
                });
            });
        },
        getGameImg(gameCode) {
            return process.env.BASE_URL + 'static/images/gamepic/' + gameCode + '_1800x810.jpg';
        },

        getGameCoverImg(gameCode) {
            return process.env.BASE_URL + 'static/images/gamepic/' + gameCode + '_2000x800.jpg';
        },
        onImgError(event) {
            const target = event.target;
            const fallback = this.defaultImgUrl;
            if (target && target.src !== fallback) {
                target.src = fallback;
            }
        },
    }
}
</script>